const downloadTooltip = {
  tooltipText: 'نحن نعمل على هذه الخاصية. نشكر لك اهتمامك.',
};

export default downloadTooltip;
